import React, { useEffect } from "react";
import { Button } from "../../../common";
import { ReactComponent as OneImage } from "../../../../assets/icons/one.svg";
import { useGetCompanyUpdatesQuery, useUpdateViewedTimestampMutation } from "../../../../store/Company/companyApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { formatDateWithOrdinalAndShortMonth } from "../../../../utils/Helper";


const FollowPopup = ({ close, companyID, follow, redirectComp }) => {
  const { token } = useSelector((state) => state.auth);
  const [updateViewedTimestamp] = useUpdateViewedTimestampMutation();
  const { data: companyUpdates, error, isLoading } = useGetCompanyUpdatesQuery({ companyID, token });
  const followID = follow?.company_follow_ID

  useEffect(() => {
    updateViewedTimestamp({ followID: followID, token: token });
  }, []);

  if (isLoading) {
    return <div><Spinner /></div>;
  }

  if (error) {
    return <div>Error fetching updates: {error.message}</div>;
  }

  return (
    <div className="text-left flex flex-col pt-4 px-2">
      <h3 className="text-secondarytwo text-f20 font-semibold my-2">
        Latest Changes!
      </h3>
      <p className="text-secondary pb-4 text-f16">
        There have been some changes in the company profile.
      </p>
      <div className="updates-section overflow-y-auto max-h-[400px] border-b pt-7 pb-28">
        {companyUpdates && companyUpdates
          .filter(update => update.content !== "Company Profile Updated")
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
          .map((update) => (
            <div className="flex items-center mb-5 pb-5 border-b pr-60">
              {/* <OneImage /> */}
              <div className="text-left px-5">
                <h4 className="text-f18 font-semibold">{update.content}</h4>
                <p className="text-f10">Updated On: {formatDateWithOrdinalAndShortMonth(update.timestamp)}</p>
              </div>
            </div>
          ))
        }
      </div>
      <div className="flex text-secondary pt-4 w-full gap-4">
        <Button
          onClick={() => { close(); redirectComp(); }}
          classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
        >
          View All Changes
        </Button>
      </div>
    </div>
  );
};

export default FollowPopup;
